var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9375 7.55556H5.25V3.66667H3V2H6.9375V7.55556ZM5.25 17.5556H3V16.4444H6.94732V22H3V20.8889H5.25V19.7778H3V18.7039H5.25V17.5556ZM3 10.8809L4.6875 10.8889L3 13.1111V14.7778H6.94732L6.9375 13.1111H5.25L6.94732 10.8809V9.22222H3V10.8809ZM8.625 5.88889V4.22222H21V5.88889H8.625ZM8.625 20.3333H21V18.6667H8.625V20.3333ZM21 13.1111H8.625V11.4444H21V13.1111Z",
    fill: "#7898FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBlue);
export default __webpack_public_path__ + "static/media/list_blue.e977de6fd556c71e3b5b84650fb53fa4.svg";
export { ForwardRef as ReactComponent };